<div class="Radio">
  <input
    type="radio"
    [id]="id"
    [value]="value"
    [checked]="checked"
    (change)="update()"
    />

    @if (label) {
      <label [for]="id">
        {{ label }}
      </label>
    }

    <span class="checkmark"></span>
  </div>